import React from 'react';
import "./WhyConnect.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

function WhyConnect() {
  return (
    <div className="wconUs">
      <div className="maxW">
        <div className="wconMn">
          <div className="wconTp">
            <h2>Why Connect With Us?</h2>
            <p>
              Your business deserves the right partner. <br />
              Let’s start the conversation today.
            </p>
            <Button
              variant="contained"
              component={Link}
              to="/contact-us"
              className="wbtnLink"
            >
              Contact Us
            </Button>
          </div>

          <div className="wconBtm">
            <div className="whyWrap">
          
              <div className="wcnbrd">
                <div className="dtBlue">
                  <div></div>
                </div>
                <h3>
                  Expert guidance tailored <br />
                  to your business needs
                </h3>
                <p>
                  Helping you make smarter decisions and achieve faster growth.
                </p>
              </div>

              <div className="wcnBdr"></div>

           
              <div className="wcnbrd">
                <div className="dtOrange">
                  <div></div>
                </div>
                <h3>Transparent, solution-first approach</h3>
                <p>
                  Puts your goals at the center and delivers results you can trust.
                </p>
              </div>

              <div className="wcnBdr"></div>

          
              <div className="wcnbrd">
                <div className="dtgreen">
                  <div></div>
                </div>
                <h3>Fast response and dedicated support</h3>
                <p>Keep your business moving without delays.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyConnect;
